import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

export class ZIDXAccountPipeline implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountPipelineContainer";
    }
    render(){
        let tables=this.zidx.peakidxShadowRoot.querySelectorAll(".zidxAccountPipelineContainer .zidxRecordSort");
        for(let i=0;i<tables.length;i++){
            this.zidx.setupRecordSort(tables[i], function(result:any){});
        }
    }
}
